/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {Tab as HeadlessTab, Unsubscribe} from '@coveo/headless';
import axios from 'axios';
import $ from 'jquery';
import React, {FunctionComponent, useEffect, useMemo, useState} from 'react';
import * as ReactRedux from "react-redux";
import {
    setActiveClearValueInputPrice,
    setActiveOKB,
    setSearchActionClearFilter,
    setIsNoResultByFilterPrice,
    setActiveINET,
    setCurrentSortState, setActiveSortState
} from '../../actions/searchBoxAction';
import Modal from "./Button/Modal";
import {
    breadcrumbs,
    CategoryFacetAEMProductType,
    CategoryFacetAEMType,
    CategoryFacetOKB, facetCommonCategoryfilter
} from '../../controllers/facetControllers';
import {generalTabQuerySummary, headlessQuerySummary} from '../../controllers/resultListControllers';
import {
    criteriaIndustry,
    criteriaInspiration,
    criteriaLearning,
    criteriaProduct,
    criteriaResource,
    criteriaSupport,
    criteriaCommulity, criteriaDownloadsInet, criteriaRecommendedDownloadsInet
} from '../../controllers/sort-criteria';
import {
    activeTabId,
    isUrlShop,
    listPillConsumer,
    numberOfResultViewMode,
    numberOfResultCommunity,
    pillId,
    pillName,
    sendDataAnalytic,
    viewMode, numberOfResultDefault, PillConsumerType
} from './../../utils/utils';
import {Facet} from './Facet/Facet';
import BreadcrumbManager from './Facet/FacetType/Breadcrumbs';
import {Category} from './Facet/FacetType/Category';
import FilterAndSort from "./FilterAndSort/FilterAndSort";
import {Recommendations} from './Recommendation/Recommendations';
import ModalQuickView from './SearchListing/ModalQuickView';
import NoResults from "./SearchListing/NoResults";
import {ResultMode} from './SearchListing/ResultMode';
import {SearchListing} from './SearchListing/SearchListing';
import './SearchResults.scss';
import {Sort} from './Sort/Sort';
import Pill from "./Pill/Pill";
import {
    globalSearchBox,
    globalSearchBoxTab,
    globalSearchBoxCGRA, generatedAnswerCRGA,
} from "../../controllers/seachBoxControllers";
import pill from "./Pill/Pill";
import {popularViewedSameCategoryRecommendationsList} from "../../controllers/recommendationControllers";
import {useSelector} from "react-redux";
import AnswerBox from "../AnswerBox/AnswerBox";
import {SortBy} from "@coveo/headless/dist/definitions/features/sort-criteria/criteria";

let SearchResultsV2: FunctionComponent<any> = (props) => {
    const [criteria, setCriteria] = useState(criteriaProduct);
    const [totalResult, setTotalResult] = useState(1);
    // typeFacet is pillId
    const [typeFacet, setTypeFacet] = useState(pillId.PRODUCT);
    const [pillConsumerSelected, setPillConsumerSelected] = useState({});
    const [isOpenMode, setOpenMode] = useState(true);
    const [resultMode, setMode] = useState(viewMode.GRID);
    const [titlePage, setTitlePage] = useState("All products");
    const [activeTab, setActiveTab] = useState(activeTabId);
    const [dataResultMagento, setdataResultMagento] = useState([]);
    const [noResultProduct, setNoResultProduct] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isShowNoResult, setIsShowNoResult] = useState(true);
    const [typeCategory, setTypeCategory] = useState(props.controller.controller.CategoryFacetProduct);
    const [isActiveType, setIsActiveType] = useState(false);
    const [isActiveProductType, setIsActiveProductType] = useState(false);
    const [isActiveSalesforce, setIsActiveSalesforce] = useState(false);
    // const [isShowRecommendedForModel, setIsShowRecommendedForModel] = useState(false);
    const [isActiveCommunity, setIsActiveCommunity] = useState(false);
    const [isActiveTab, setIsActiveTab] = useState(false);
    const [isActiveProductsPill, setIsActiveProductsPill] = useState(false);
    const [isTriggerFirstLoad, setIsTriggerFirstLoad] = useState(false);
    const [prevQuery, setPrevQuery] = useState("");
    const [isClickCategory, setIsClickCategory] = useState(false);
    const [isFirstLoadPage, setIsFirstLoadPage] = useState(true);
    //isCategoryLength for re-render Category when numberOfResults of category no change
    const [isCategoryLength, setIsCategoryLength] = useState(0);
    const [currentCategoryFacet, setCurrentCategoryFacet] = useState <PillConsumerType | null>();
    const initSkus: string[] = [];
    const [recommendationSkus, setRecommendationSkus] = useState(initSkus);
    const isActiveINET = useSelector((state: any) => state.searchBoxReducer.isActiveINET);
    // historyResult for remove unneccesary sku in payload
    const historyResult: string[][] = [];
    const dispatch = ReactRedux.useDispatch();
    let pillProductsActive: boolean = false;
    // Refactor start
    const [pillList, setPillList] = useState(listPillConsumer);
    let activePill = {};
    let openProductPill = false;
    const selectDefaultPill = () => {
        const url_string = decodeURI(window.location.href);
        const url = new URL(url_string);
        let isUrlIncludeShop: string | null = url.searchParams.get("r");

        if (isUrlIncludeShop === isUrlShop.NOT_SHOP) {
            openProductPill = true;
        }
    }

    selectDefaultPill();

    useEffect(() => {
        let active = {...pillList[1]};
        if (openProductPill) {
            active = {...pillList[0]};
        }
        active.state = "selected";
        if (localStorage.getItem("searchSuggestion") != null) {
            // @ts-ignore
            globalSearchBox.selectSuggestion(localStorage.getItem("searchSuggestion"));
            localStorage.removeItem("searchSuggestion");
        } else {
            globalSearchBox.submit();
        }
        // @ts-ignore
        facetCommonCategoryfilter.toggleSingleSelect(active);
        togglePill(null, active, pillList);
        setCurrentCategoryFacet(active);
    }, []);
    useEffect(() => {
        //@ts-ignore
        if (window.refreshPage && props.controller.resultList.state.results?.length > 0) {
            //@ts-ignore
            window.refreshPage = false
        }
    }, [props.controller.resultList.state.searchResponseId])
    useEffect(() => {
        //isCategoryLength for re-render Category when numberOfResults of category no change
        facetCommonCategoryfilter.subscribe(() => {
            setIsCategoryLength(facetCommonCategoryfilter.state.values.length);
        });
    },[]);
    useEffect(() => {
        if (facetCommonCategoryfilter.state && !facetCommonCategoryfilter.state.isLoading && facetCommonCategoryfilter.state.values.length > 0) {
            console.log("pillList",facetCommonCategoryfilter.state)
            const facetPills = facetCommonCategoryfilter.state.values;
            let pills = JSON.parse(JSON.stringify(listPillConsumer));
            let productPill: any;
            let supportPill: any;
            pills.forEach((pill: any) => {
                const matchItem = facetPills.find((facet: any) => pill.value === facet.value);
                pill.numberOfResults = matchItem ? matchItem.numberOfResults : pill.numberOfResults;
                pill.state = matchItem ? matchItem.state : pill.state;
                // @ts-ignore
                pill.isSelected = facetCommonCategoryfilter.isValueSelected(matchItem ? matchItem : pill);
                if (pill.id === pillId.PRODUCT) {
                    productPill = pill;
                }
                if (pill.id === pillId.SUPPORT) {
                    supportPill = pill;
                }
            });
            if (currentCategoryFacet && (productPill.numberOfResults > 0 || supportPill.numberOfResults > 0)) { 
                if (currentCategoryFacet.id === productPill.id && productPill.numberOfResults == 0) {
                    let currentResponseId = props.controller.resultList.state.searchResponseId;
                    supportPill.state = "selected";
                    supportPill.isSelected = true;
                    togglePill(null, supportPill, pills);
                    //@ts-ignore
                    window.bypassCategoryNoresult = true;
                    let unsubscribe = props.controller.resultList.subscribe(() => {
                        if (currentResponseId != props.controller.resultList.state.searchResponseId) {
                            //@ts-ignore
                            window.bypassCategoryNoresult = false;
                            unsubscribe();
                        }
                    });
                    return;
                } 
                if (currentCategoryFacet.id === supportPill.id && (supportPill.numberOfResults == 0)) {
                    togglePill(null, productPill, pills);
                    return;
                }               
            }
            if (productPill.numberOfResults > 0 && supportPill.numberOfResults == 0) {
                activePill = productPill;
            } else if (productPill.numberOfResults == 0 && supportPill.numberOfResults > 0) {
                activePill = supportPill;
            } else if (openProductPill) {
                activePill = productPill;
            } else {
                activePill = supportPill;
            }
            setPillList(pills);
        }
    }, [facetCommonCategoryfilter.state.values]);

    useMemo(() => {
        setTimeout(() => {
            setIsTriggerFirstLoad(true);
        }, 2500);
    }, [props.searchClearFilter]);

    useEffect(() => {
        props.controller.headlessQuerySummary.subscribe(() => {
            setTotalResult(props.controller.headlessQuerySummary.state.total);
        });
    }, []);

    useEffect(() => {
        if (typeFacet !== pillId.PRODUCT) {
            if (typeFacet === pillId.SUPPORT) {
                setTypeCategory(props.controller.controller.CategoryFacetSupport);
            } else if(typeFacet === pillId.COMMUNITY) {
                setTypeCategory(props.controller.controller.CategoryFacetAEMCategoryCommunity);
            } else {
                setTypeCategory(props.controller.controller.CategoryFacet);
            }
        } else {
            setTypeCategory(props.controller.controller.CategoryFacetProduct);
        }
        if (props.controller.breadcrumbs.state.hasBreadcrumbs) {
            props.controller.breadcrumbs.deselectAll();
            //@ts-ignore
            facetCommonCategoryfilter.toggleSingleSelect(currentCategoryFacet);
        }
        if (typeFacet === pillId.COMMUNITY) {
            props.controller.controller.facetType.facetSearch.select({
                displayValue: "Solved",
                rawValue:"Solved",
                count: 0
            });
        }
    }, [typeFacet]);


    const getCurrentPillInURL = () => {
        const url_string = decodeURI(window.location.href);
        const url = new URL(url_string);
        return url.searchParams.get("r") || "support";
    }

    useEffect(() => {
        props.controller.resultList.subscribe(() => {
            // update historyResult format [history1, history2] // history2 is latest
            if (isFirstLoadPage && !props.controller.resultList.state.isLoading && props.controller.resultList.state.searchResponseId != "") {
                setIsFirstLoadPage(false);
            }
            let currentPill = getCurrentPillInURL();
            //@ts-ignore
            if (window.searchBoxEntered) {
                //@ts-ignore
                window.searchBoxEntered = false;
                setPillList((prevPillList) => {
                    prevPillList.forEach((item, index, newList) => {
                        item.isSelected = false;
                        if (item.value.toLowerCase() === currentPill) {
                            item.isSelected = true;
                            changeFacetAndSort(item);
                            setCurrentCategoryFacet(item);
                            setPillConsumerSelected(item);
                        }
                        newList[index] = item;
                    });
                    return prevPillList;
                })
            }
            if (Array.isArray(historyResult) && historyResult.slice(-1).length !== props.controller.resultList.state.results.length ){
                const newHistory: string[] = props.controller.resultList.state.results.map((x:any) => x.raw.sku);
                historyResult.push(newHistory);
                if(historyResult.length > 2){
                    historyResult.shift()
                }
            }
            let productCategory = facetCommonCategoryfilter.state.values.filter((item: any) => ["product"].includes(item.value.toLowerCase()));
            if (productCategory.length > 0 && productCategory[0].state === "selected" && !props.controller.resultList.state.isLoading) {
                console.log("load more!!!")
                const skusArray: string[] = [];
                let skuNoUndefined = false;
                if (props.controller.resultList.state.results.length) {
                    for (let index = 0; index < (props.controller.resultList.state.results.length); index++) {
                        let productResult = props.controller.resultList.state.results[index] || {};
                        // check if SKU already called by GraphQL
                        if (historyResult.length > 1 ) {
                            let prevHistory: string[] = historyResult[historyResult.length - 2];
                            if (prevHistory.some((item)=>item === productResult.raw.sku)) {
                                continue;
                            }
                        }
                        if (productResult.childResults && productResult.childResults.length > 0) {
                            productResult.childResults.map(
                                (childResult: any) => {
                                    if (["Variant", "Product"].includes(childResult.raw.objecttype)) {
                                        skusArray.push(childResult.raw.sku);
                                    }
                                }
                            );
                        }
                        skusArray.push(productResult.raw.sku);
                        //check has sku and skuNoUndefined false
                        if (!skuNoUndefined && props.controller.resultList.state.results[index]?.raw.sku) {
                            skuNoUndefined = true;
                        }
                    }
                }
                const url_string = decodeURI(window.location.href);
                const url = new URL(url_string);
                if (!recommendationSkus || recommendationSkus.length == 0 || prevQuery != url.searchParams.get("q")) {
                    setPrevQuery(url.searchParams.get("q") || "");
                    setRecommendationSkus(skusArray);
                }

                const stringConvert: string = skusArray.reduce((stringconverttotal, sku) => (stringconverttotal + `"${sku}"` + ","), "");
                // const domain = "https://webdev.usa.canon.com/shop/att/graphql?";
                //if run product ->
                const domain = `${
                    (window.location.hostname === "localhost"
                        ? "https://webqa.usa.canon.com"
                        : window.location.origin) + "/shop/graphql?"
                }`;
                let query = `{productListInfo(skus:[${stringConvert}]) {products{name sku product_url eight_digits_sku stock_status free_shipping free_shipping_label discontinued_product special_offer price}}}`;
                let queryString = `query=` + encodeURIComponent(query);
                if (skuNoUndefined) {
                    axios.get(`${domain + queryString}`)
                        .then(res =>
                            setdataResultMagento(res.data.data?.productListInfo?.products)
                        );
                }
            }
        });
    }, []);

    // using firstload icon ignore no result component
    useEffect(() => {
        if (currentCategoryFacet && ["product", "support"].includes(currentCategoryFacet!.value.toLowerCase())) {
            if (isFirstLoad) {
                localStorage.removeItem("searchResultDownloadFile");
            }
            if (!isClickCategory && props.controller.resultList.state.results.length > 0) {
                const url_string = decodeURI(window.location.href);
                const url = new URL(url_string);
                let keyWord = url.searchParams.get("q") || "";
                let countWord = keyWord.split(" ").filter((item) => item !== "").length;
                let keyWordCondition = document.getElementById("coveo-config")?.getAttribute("data-coveo-crga-keyword-condition") || 3;
                if (globalSearchBoxCGRA.state.value !== keyWord && countWord >= Number(keyWordCondition)) {
                    globalSearchBoxCGRA.updateText(keyWord);
                    globalSearchBoxCGRA.submit();
                }
            }
            setIsFirstLoad(false);
        } else {
            if (currentCategoryFacet && ["community"].includes(currentCategoryFacet!.value.toLowerCase()) && props.controller.resultList.state.results.length <= 0) {
                setIsShowNoResult(false);
            } else {
                setIsShowNoResult(true);
            }
        }
        setIsClickCategory(false);
    }, [props.controller.resultList.state.results]);

    // Switch grid/list view mode in Product pill and set default mode for other pills
    const changeView = (view: string) => {
        if (viewMode.GRID === view || viewMode.LIST === view) {
            const pillElement = document.querySelector(".pill-container #Product");
            if (viewMode.LIST === view) {
                pillElement?.classList.add("is-ready");
            }
            setMode(view);
        } else return;
    };

    useEffect(() => {
        const pillElement = document.querySelector(".pill-container #Product");
        const noOfResults = document.querySelector(".noOfResultContainer");
        if (currentCategoryFacet && ["product"].includes(currentCategoryFacet!.value.toLowerCase())) {
            setOpenMode(true);
            if (!pillElement?.classList.contains("is-ready") || (pillElement?.classList.contains("is-ready") && resultMode === viewMode.GRID)) {
                setMode(viewMode.GRID);
            }
            // Set width for noOfResults section for Products pill only
            noOfResults?.classList.add("noOfResultResize");
        } else {
            setOpenMode(false);
            setMode(viewMode.LIST);
            pillElement?.classList.remove("is-ready");
            // Remove Products width if selecting other pill
            noOfResults?.classList.remove("noOfResultResize");
        }
    });

    // Render the list of pills with the input default pill list (defined in utils.tsx file)
    function renderPillList(pills: { value: string; numberOfResults: number; }[], isMobile:boolean) {
        let tabId = "consumerPillar";
        if (isMobile) {
            tabId = tabId + "_isMobile"
        }

        const validPills = pills.filter((pill) => pill.numberOfResults > 0);
        const isHidePill = validPills.length === 1;

        return (
            <div className={`tab-pane fade show active ${(isHidePill && !isMobile) && 'hidden'}`} id={tabId} role="tabpanel" aria-labelledby={tabId}>
                <div className="pill-container">
                    <div className="pill-tilte" style={{"fontWeight": "bold", "display": isMobile ? "none" : "block"}}>Category</div>
                    <div className="pills-list">
                        {isMobile && (<FilterAndSort controller={props.controller.controller.breadcrumbs}/>)}
                        {validPills.map((pill: any, index) => {
                            return (<Pill key={pill.value} id={pill.value}
                                          onClick={(e) => {
                                              if (["Support", "Product"].includes(pill.value)) {
                                                  setIsClickCategory(true);
                                              }
                                              setPillList((prevPillList) => {
                                                  prevPillList.forEach((item, index, newList) => {
                                                      item.isSelected = false;
                                                      item.state = "idle";
                                                      if (item.value.toLowerCase() === pill.value.toLowerCase()) {
                                                          item.isSelected = true;
                                                          item.state = "selected";
                                                          changeFacetAndSort(item);
                                                          setPillConsumerSelected(item);
                                                      }
                                                      newList[index] = item;
                                                  });
                                                  return prevPillList;
                                              })
                                              togglePill(e, pill);
                                          }} value={pill.value}
                                          numberOfResults={pill.numberOfResults}
                                          isSelected={pill.isSelected}
                                          isMobile={isMobile}
                                          isHidden={isHidePill}/>);
                        })}
                    </div>
                </div>
            </div>
        );
    }

    // Update facet options and sort options basing on the selected pill
    function changeFacetAndSort(pill: { id: number, title: string, value: string; }) {
        let title;
        switch (pill.value) {
            case pillName.PRODUCT:
                setTypeFacet(pillId.PRODUCT);
                setCriteria(criteriaProduct);
                title = pillName.PRODUCT + " Type";
                break;
            case pillName.INDUSTRIES:
                setTypeFacet(pillId.INDUSTRIES);
                setCriteria(criteriaIndustry);
                title = pillName.INDUSTRIES + " Type";
                break;
            case pillName.INSPIRATION:
                setTypeFacet(pillId.INSPIRATION);
                setCriteria(criteriaInspiration);
                title = pillName.INSPIRATION + " Type";
                break;
            case pillName.RESOURCES:
                setTypeFacet(pillId.RESOURCES);
                setCriteria(criteriaResource);
                title = pillName.RESOURCES + " Type";
                break;
            case pillName.SUPPORT:
                setTypeFacet(pillId.SUPPORT);
                setCriteria(criteriaSupport);
                title = pillName.SUPPORT + " Type";
                break;
            case pillName.LEARNING:
                setTypeFacet(pillId.LEARNING);
                setCriteria(criteriaLearning);
                title = pillName.LEARNING + " Type";
                break;
            case pillName.COMMUNITY:
                setTypeFacet(pillId.COMMUNITY);
                setCriteria(criteriaCommulity);
                title = pillName.COMMUNITY + " Type";
                break;
        }
        setTitlePage(title ?? pill.title);
    }

    const [unsub, setUnsub] = useState<Unsubscribe>();

    function togglePill(e: any, pill: any, currentPillList?: any) {
        if (unsub) {
            unsub();
        }
        setCurrentCategoryFacet(pill);
        changeFacetAndSort(pill);
        $('.datepicker').datepicker('setDate', null);
        setPillConsumerSelected(pill);
        // let pillarController: HeadlessTab = productPill;
        // let pillActive = "product";
        // if (pill.id === pillId.SUPPORT) {
        //     pillarController = supportPill;
        //     pillActive = "support";
        // } else if (pill.id === pillId.LEARNING) {
        //     pillarController = learningPill;
        // } else if (pill.id === pillId.INSPIRATION) {
        //     pillarController = inpirationPill;
        // } else if (pill.id === pillId.INDUSTRIES) {
        //     pillarController = industriesPill;
        // } else if (pill.id === pillId.RESOURCES) {
        //     pillarController = resourcesPill;
        // } else if (pill.id === pillId.COMMUNITY) {
        //     pillarController = communityPill;
        // }
        setIsActiveType(false);
        setIsActiveProductType(false);
        setIsActiveSalesforce(false);
        dispatch(setActiveOKB({value: false}))
        dispatch(setActiveINET({value: false}));
        if(pill.id === pillId.COMMUNITY) {
            props.controller.buildGridViewResultListProduct.set(numberOfResultCommunity);
        } else {
            if (!props.controller.buildGridViewResultListProduct.isSetTo(numberOfResultDefault)) {
                props.controller.buildGridViewResultListProduct.set(numberOfResultDefault);
            }
        }
        if (!props.controller.sort.isSortedBy({by: "relevancy"})) {
            props.controller.sort.sortBy({
                by: "relevancy"
            });
        }
        dispatch(setCurrentSortState({value: "Most Relevant"}));
        dispatch(setActiveSortState({value: false}));

        // let un = pillarController.subscribe(() => {
        //     let pills = JSON.parse(JSON.stringify(currentPillList ? currentPillList : pillList));
        //     pills.forEach((pill_in: any) => {
        //         pill_in.isSelected = pill.value === pill_in.value;
        //     })
        //     setPillList(pills);
        // });
        // setUnsub(un);
    }

    function closeFacetContainer() {
        var leftNav = document.getElementsByClassName("sc_leftNavListDiv")[0];
        if (leftNav.classList.contains("mobile-active_show")) {
            leftNav.classList.remove("mobile-active_show");
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
    }

    function triggerClearAllBreadcrumbs() {
        breadcrumbs.deselectAll();
        //Set the default Sort value to Most Relevant
        props.controller.sort.sortBy({
            by: "relevancy"
        })
        //@ts-ignore
        facetCommonCategoryfilter.toggleSingleSelect(currentCategoryFacet);
        dispatch(setCurrentSortState({value: "Most Relevant"}));
        dispatch(setActiveSortState({value: false}));
        let endDate =document.querySelector("#endDate") as HTMLInputElement;
        let startDate =document.querySelector("#startDate") as HTMLInputElement;
        if (startDate) {
            startDate.value = "" ;
        }
        if (endDate) {
            endDate.value = ""
        }
    }

    function expandCollapseAccordion(e: any) {
        const accordion = e.target;
        const children = e.target.nextElementSibling;

        if (!accordion.classList.contains("collapsed")) {
            accordion.classList.add("collapsed");
            children.classList.add("deactive");
        } else {
            accordion.classList.remove("collapsed");
            children.classList.remove("deactive");
        }
    }

    // Render main result section
    function renderFacetSortResultList() {
        const url_string = decodeURI(window.location.href);
        const url = new URL(url_string);
        const searchKeyword = url.searchParams.get("q") ? `for "${url.searchParams.get('q')}"` : "";
        const hideInMobile = typeFacet === pillId.INDUSTRIES || typeFacet === pillId.INSPIRATION ? 'leftnavcategory hideInMobile' : 'leftnavcategory';
        const searchTerm = typeFacet === pillId.PRODUCT ? "" : ` ${searchKeyword}`;
        let isMobileView = window.innerWidth < 768;
        return (
            <div>
                { props.isNoResultByFilterPrice &&
                <div className="filter-price-no-result-message-error">
                    <div className="message-content">We didn’t find any products that matches your filters. We’ve removed your Price filter</div>
                    <div className="close" onClick={() => dispatch(setIsNoResultByFilterPrice(false))}></div>
                </div>
                }
                <div className="searchInnerDiv">
                    <div className="sc_leftNavListDiv mobile-active">
                        <div className="filterSortOverlay" onClick={() => closeFacetContainer()}></div>
                        <div className="navsection">
                            <div className="filterSortHeader">
                                <div className="filterSortTilte"><h4>Filter & Sort</h4></div>
                                <span className="filterSortClose" onClick={() => closeFacetContainer()}></span>
                            </div>
                            <div className="leftnavsection">
                                <Sort
                                    isMobile={true}
                                    currentSort={props.currentSort}
                                    activeSort={props.activeSort}
                                    controllerTabPill={props.controller}
                                    controller={props.controller.sort}
                                    criteria={isActiveINET ? props.isShowRecommendedForModel ?   criteriaRecommendedDownloadsInet : criteriaDownloadsInet : criteria}
                                    isShowRecommendedForModel={props.isShowRecommendedForModel}
                                    pillType={typeFacet}
                                    tabType={activeTab}
                                />
                                {renderPillList(pillList, false)}
                                <div className="filter-title-mobile">Filter by</div>
                                <div className={hideInMobile}>
                                    { typeFacet !== pillId.INDUSTRIES && typeFacet !== pillId.INSPIRATION && (
                                        <button className={"facet-category" + (isMobileView ? " collapsed":"")} onClick={(e) => expandCollapseAccordion(e)}>
                                            {titlePage}
                                        </button>
                                    )}
                                    {
                                        typeFacet !== pillId.INDUSTRIES && typeFacet !== pillId.INSPIRATION && (
                                            <Category isActiveSalesforce={isActiveSalesforce} setIsActiveSalesforce={setIsActiveSalesforce}
                                                      isActiveType={isActiveType} isActiveProductType={isActiveProductType}
                                                      currentCategoryFacet={currentCategoryFacet}
                                                      setIsActiveType={setIsActiveType} setIsActiveProductType={setIsActiveProductType}
                                                      controller={typeCategory} />)
                                    }
                                </div>
                                <BreadcrumbManager setIsActiveType={setIsActiveType} setIsActiveProductType={setIsActiveProductType}
                                                   setIsActiveSalesforce={setIsActiveSalesforce} isAffiliate={false} typeFacet={typeFacet}
                                                   listFacetDeSelectAll={props.controller.controller}
                                                   isOffsetTop={false}
                                                   controller={props.controller.controller.breadcrumbs}
                                                   currentCategoryFacet={currentCategoryFacet}
                                                   controllerFacetPill={props.controller.controller}/>
                                <Facet isAffiliate={false} pillConsumerSelected={pillConsumerSelected} type={typeFacet}
                                       isActiveINET={isActiveINET}  isShowRecommendedForModel={props.isShowRecommendedForModel} controller={props.controller.controller}/>
                            </div>
                            <div className="facetClearCloseMobile">
                                <button onClick={() => triggerClearAllBreadcrumbs()} className="clear-allfilter-mobile">Clear all</button>
                                <button onClick={() => closeFacetContainer()} className="close-facet-mobile">VIEW RESULTS</button>
                            </div>
                        </div>
                    </div>
                    <div className="rightSectionDiv">
                        {(currentCategoryFacet && ["product", "support"].includes(currentCategoryFacet!.value.toLowerCase())) && <AnswerBox globalSearchBoxCGRAController={globalSearchBoxCGRA} controller={generatedAnswerCRGA}/>}
                        <div className="rightSectionHeader">
                            {/*{*/}
                            {/*    totalResult > 0 &&*/}
                            {/*    (*/}
                            {/*        <div className="noOfResultContainer">*/}
                            {/*            {totalResult}*/}
                            {/*            {totalResult === 1 ? ` Result${searchTerm}` : ` Results${searchTerm}`}*/}
                            {/*        </div>*/}
                            {/*    )*/}
                            {/*}*/}
                            {renderPillList(pillList, true)}
                            {isOpenMode && <ResultMode resultMode={resultMode} changeView={changeView}/>}
                            <Sort
                                currentSort={props.currentSort}
                                activeSort={props.activeSort}
                                controllerTabPill={props.controller}
                                controller={props.controller.sort}
                                criteria={isActiveINET ? props.isShowRecommendedForModel ?   criteriaRecommendedDownloadsInet : criteriaDownloadsInet : criteria}
                                isShowRecommendedForModel={props.isShowRecommendedForModel}
                                pillType={typeFacet}
                                tabType={activeTab}
                            />
                        </div>
                        <div className="showPageData">
                            {typeFacet === pillId.PRODUCT && (
                                <Recommendations typeFacet={typeFacet} openResultMode={isOpenMode}
                                                 controller={props.controller.popularViewedRecommendationsList}
                                                 skus={recommendationSkus}/>
                            )}
                            <SearchListing tabType={activeTab} typeFacet={typeFacet} data={dataResultMagento}
                                           openResultMode={isOpenMode} resultMode={resultMode}
                                           controller={props.controller.resultList}
                                           buildGridViewResultListProduct={props.controller.buildGridViewResultListProduct}
                                           isShowRecommendedForModel={props.isShowRecommendedForModel}
                                           isNoMostPopular={props.isNoMostPopular}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
//@ts-ignore
let refreshPage = window.refreshPage;

    return (
        // add new class for override css on affiliate
        <div className="searchComponentContainer">
            <div className="searchComponentWrapper">
                <ModalQuickView></ModalQuickView>
                <div className="tab-content">
                    {
                        !isFirstLoad && (props.actionSearchBox && (noResultProduct || refreshPage || totalResult === 0) && isShowNoResult?
                                <NoResults isTriggerFirstLoad={isTriggerFirstLoad} controller={props.controller.resultList}/> :
                                renderFacetSortResultList()
                        )
                    }
                </div>
            </div>
        </div>
    );
};

SearchResultsV2 = ReactRedux.connect((state: any, ownProps) => {
    return {
        ...ownProps,
        actionFilter: state.searchBoxReducer.actionFilter,
        actionSearchBox: state.searchBoxReducer.actionSearchBox,
        searchClearFilter: state.searchBoxReducer.searchClearFilter,
        isNoMostPopular: state.searchBoxReducer.isNoMostPopular,
        isNoResultByFilterPrice: state.searchBoxReducer.isNoResultByFilterPrice,
        isShowRecommendedForModel: state.searchBoxReducer.isShowRecommendedForModel,
        isActiveINET: state.searchBoxReducer.isActiveINET,
        currentSort: state.searchBoxReducer.currentSort,
        activeSort: state.searchBoxReducer.activeSort
    };
})(SearchResultsV2);

export default SearchResultsV2;